export const ABSENCES_GET = 'ABSENCES_GET';
export const ABSENCE_ADD = 'ABSENCE_ADD';
export const ABSENCE_EDIT = 'ABSENCE_EDIT';
export const ABSENCE_GET = 'ABSENCE_GET';
export const ABSENCE_DELETE = 'ABSENCE_DELETE';
